<template>
    <div class="main_box">
        <a-spin :spinning="chartloading">
            <div class="dashBox">
                <div class="dashTitle">
                    <div class="blockT">
                        <div class="castitle"><a-icon type="line-chart" style="color:#ffdd55;margin-right:4px;" />总PV</div>
                        <div class="castbl">
                            <span class="castvalue">{{sumPV}}</span>
                            <span class="castsub">同比</span>
                            <span :class="[pvT[0] == '-' ? 'redClass' : 'greenClass']" >{{ pvT }} <a-icon style="margin-left:4px;" :type="pvT[0] == '-' ? 'arrow-down' : 'arrow-up'" /></span>

                        </div>
                    </div>
                    <div class="blockT">
                        <div class="castitle"><a-icon type="line-chart" style="color:#57d4e2;margin-right:4px;" />总UV</div>
                        <div class="castbl">
                            <span class="castvalue">{{sumUV}}</span>
                            <span class="castsub">同比</span>
                            <span :class="[uvT[0] == '-' ? 'redClass' : 'greenClass']" >
                                {{ uvT }} 
                                <a-icon v-if="uvT" style="margin-left:4px;" :type="uvT[0] == '-' ? 'arrow-down' : 'arrow-up'" />
                            </span>
                        </div>
                    </div>
                    <a-select mode="default" v-model="chartPerTime" @change="handleChartPerTimeChange"
                        style="width: 80px;float:right;margin-top:2px;" placeholder="请选择时间">
                        <a-select-option v-for="(value,name) in perTimeValue" :key="name" :value="name">
                            {{name}}
                        </a-select-option>
                    </a-select>
                </div>
                <a-empty v-if="dateList.length == 0" description="暂无数据" style="margin-top:80px;" />
                    <div id="pvuvChart" style="width: 100%;padding-top:10px;"></div>
            </div>
        </a-spin>
</div>
</template>

<script>
const perTimeValue = {
    '1秒':'1s',
    '1分钟':'1m',
    '5分钟':'5m',
    '10分钟':'10m',
    '1小时':'1h',
    '1天':'1d',
}



export default {
    data(){
        return {
            perTimeValue,
            sumChartValue:0,
            dateList:[],
            seriesList:[],
            chartPerTime:'1分钟',
            chartSys:null,
            tempHostName:'',
            tempEnv:'',
            tempTimeRange:'',
            sumPV:0,
            sumUV:0,
            pvT:0,
            uvT:0,
            chartloading:false
        }
    },
    methods:{
        getRealChartTime(timeType){
            // '1分钟':7,
            // '5分钟':8,
            // '15分钟':10,
            // '1小时':9
            let result = '1分钟';
            switch (timeType) {
                case '1天':
                    //每小时
                    result = '1小时'
                    break;
                case '1小时':
                    //每小时
                    result = '5分钟'
                    break;
                case '15分钟':
                    //每15分钟
                    result = '1分钟'
                    break;
                case '5分钟':
                    //5分钟
                    result = '1秒'
                    break;
                case '1分钟':
                    //1分钟
                    result = '1秒'
                    break;
                default:
                    break;
            }
            return result;
        },
        loadData(selectedEnv,hostName,timeRange,flag){
            //cc
            this.tempHostName = hostName;
            this.tempEnv = selectedEnv;
            this.tempTimeRange = timeRange;
            let that = this;
            timeRange = timeRange.split('~');
            let starttime = (new Date(timeRange[0]).getTime())/1000;
            let endtime = (new Date(timeRange[1]).getTime())/1000;
            if(flag != 1){
                that.chartPerTime = that.getRealChartTime(timeRange[2]);
            }
            let perN = that.perTimeValue[that.chartPerTime];
            let queryStr = "* | select COUNT(1) as pv,approx_distinct(device_id) as uv,time_series(__time__, '"+perN+"', '%Y-%m-%d %H:%i:%s' ,'0') as occurtime from log where project_name = '"+hostName+"' and log_type='pv' group by occurtime order by occurtime";
            that.chartloading = true;
            let params = {
                projectname:'fp-zl-device',
                logstorename:selectedEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.dateList = [];
                    that.seriesList = [];
                    that.sumPV = 0;
                    that.sumUV = 0;
                    let array = res.data.data.list
                    let tempValuesPV = [];
                    let tempValuesUV = [];
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        let tempTime = "";
                        if(that.chartPerTime == '1秒'){
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm:ss');
                        }
                        else{
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm');
                        }
                        that.dateList.push(tempTime);
                        tempValuesPV.push(element.pv);
                        tempValuesUV.push(element.uv);
                        that.sumPV += parseInt(element.pv);
                        that.sumUV += parseInt(element.uv);
                    }

                    that.seriesList.push({
                        name:'pv',
                        type: 'line',
                        smooth: true,
                        stack: '总量1',
                        itemStyle: {
                            normal: {
                                color: '#ffdd55',
                                borderColor: '#ffdd55',
                                areaStyle: {
                                    type: 'default',
                                    opacity: 0.1
                                }
                            }
                        },
                        data: tempValuesPV,
                    })
                    that.seriesList.push({
                        name:'uv',
                        type: 'line',
                        smooth: true,
                        stack: '总量2',
                        itemStyle: {
                            normal: {
                                color: '#57d4e2',
                                borderColor: '#57d4e2',
                                areaStyle: {
                                    type: 'default',
                                    opacity: 0.1
                                }
                            }
                        },
                        data: tempValuesUV
                    })
                    that.analystData();
                    //获取同比数据
                    that.getPvSumTongbi(starttime,endtime,hostName,selectedEnv,timeRange[0],timeRange[1])
                }
                else{
                    that.chartloading = false;
                }
            }).catch(() => {
                that.chartloading = false;
            });
            
        },
        getPvSumTongbi(starttime,endtime,hostName,selectedEnv,sTime,eTime){
            that.chartloading = true;
            let timerange = ( (new Date(eTime)).getTime() - (new Date(sTime)).getTime()) / 1000;
            let queryStr = "* | SELECT concat(cast(avg(round((pvt[3]-1.0)*100, 2)) AS varchar),'%') AS growperpvt, "+
                            "concat(cast(avg(round((uvt[3]-1.0)*100, 2)) AS varchar),'%') AS growperuvt from( "+
                            " SELECT compare(pv, "+timerange+") as pvt,"+
                            "compare(uv, "+timerange+") as uvt FROM (select COUNT(1) as pv,"+
                            "approx_distinct(\"__tag__:__client_ip__\") as uv "+
                            "FROM log where project_name = '"+hostName+"' and type='pv'))";
            let that = this;
            let params = {
                projectname:'fp-zl-device',
                logstorename:selectedEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let resD = res.data.data.list;
                    if(resD.length > 0){
                        that.pvT = resD[0].growperpvt == 'NaN%' ? '' : resD[0].growperpvt;
                        that.uvT = resD[0].growperuvt == 'NaN%' ? '' : resD[0].growperuvt;
                    }
                }
                that.chartloading = false;
            }).catch(() => {
                that.chartloading = false;
            });
        },
        handleChartPerTimeChange(v){
            let timeRanges = this.tempTimeRange.split('~');
            timeRanges[2] = v;
            this.loadData(this.tempEnv,this.tempHostName,timeRanges.join('~'),1);
        },
        //按日期统计数据
        analystData(){
            
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("pvuvChart").style.height = "300px";
            that.chartSys = that.$echarts.init(document.getElementById("pvuvChart"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
               
            });
            
        },
        getDatailOption(){
            let that = this;
           
            // 基于准备好的dom，初始化echarts实例
            // 绘制图表配置
            let option = {
                title: {
                    show: false
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                color:['#ffdd55','#57d4e2'],

                legend: {
                    data: ['pv','uv'],
                    left: 'center',
                    top:'top',
                    show:false,
                },
                grid: {
                    top:'25px',
                    bottom:'30px'
                },
                xAxis: [
                    {
                        type: 'category',
                        data: that.dateList.map(function (str) {
                            return str.replace(' ', '\n');
                        })
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: that.seriesList
            };
            return option
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted(){
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },

    props:{
    },
    components:{
    },
};
</script>

<style lang="less" scoped>
.main_box{
    width: calc(100% - 360px);
    height: auto;
    float: left;
    margin-left: 20px;
}
.dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
    }
    .dashTitle{
        width: 100%;
        padding:10px 10px;
        border-bottom: 1px solid lightgray;
        cursor: default;
    }

    .castitle{
        width: 100%;
        color: #a9abad;
        font-size: 14px;
    }
    .castbl{
        width: 100%;
    }

    .castvalue{
        color: #394043;
        font-weight: bold;
        font-size: 22px;

    }

    .castsub{
        color: #a9abad;
        font-size: 14px;
        margin-left: 10px;
    }

    .blockT{
        width: 200px;
        display: inline-block;
    }

    .greenClass{
        color: #6ac990;
        padding-left: 4px;
    }

    .redClass{
        color: red;
        padding-left: 4px;
    }

</style>
